import { createFileRoute, Link } from "@tanstack/react-router";
import { feedQueryOptions } from "../queries/deals";
import { Feed } from "../components/feed";

export const Route = createFileRoute("/tag/$slug")({
  loader: ({ context, params }) => {
    void context.queryClient.prefetchInfiniteQuery(
      feedQueryOptions({ sort: "hot", tag: params.slug }),
    );
  },
  component: TagPage,
});

function TagPage() {
  const { slug } = Route.useParams();
  return (
    <main className="mx-auto w-full max-w-3xl px-4 sm:px-5 py-6 sm:py-8 flex-1">
      <p className="text-xs text-[color:var(--color-fg-muted)] mb-2">
        <Link to="/" className="hover:underline">← back</Link>
      </p>
      <h1 className="text-xl font-semibold tracking-tight mb-4">Tag: #{slug}</h1>
      <Feed sort="hot" tag={slug} />
    </main>
  );
}
